import * as RosenauUI from "@rosenau/rosenau-ui";

export default function getAPIErrorMessage(error: any): string {
    if (error.response && error.response.data && error.response.data.statusMessage) {
        return error.response.data.statusMessage;
    }

    return RosenauUI.getErrorMessage(error);
}
